import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Collapse, Checkbox, Switch, Form, Radio, } from 'antd';
import clsx from 'clsx';
import { txt } from 'libs/i18n';
import { getProfilesForLanguage } from 'libs/locales/language-utils';
import FileSettings from './FileSettings';
import AfterUploadWarning from './AfterUploadWarning';
import TranscriberSettings from './TranscriberSettings';
import styles from './style.module.less';
import formStyles from '../style.module.less';
const AdvancedSettings = ({ allOrigins, originsList, selectedSource, language, profilesState, profiles, onProfileChange, }) => {
    const profilesForCurrentLanguage = useMemo(() => getProfilesForLanguage(profiles, language), [profiles, language]);
    const renderTranscriberSettings = useMemo(() => (_jsx(TranscriberSettings, { profiles: profiles, profilesState: profilesState, language: language, selectedSource: selectedSource, onChange: onProfileChange })), [profiles, profilesState, language]);
    const collapseItems = useMemo(() => [
        {
            key: '1',
            label: txt('advancedSettings'),
            forceRender: true,
            children: (_jsxs(_Fragment, { children: [renderTranscriberSettings, profilesForCurrentLanguage.length > 1 && (_jsx(AfterUploadWarning, { profiles: profiles })), selectedSource !== 'mic' && (_jsx(Form.Item, { name: "useVAD", label: txt('recordingQuality'), className: formStyles.label, children: _jsx(Radio.Group, { className: formStyles.radioGroup, options: [
                                { value: true, label: txt('useVAD') },
                                { value: false, label: txt('doNotUseVAD') },
                            ] }) })), _jsx(FileSettings, { allOrigins: allOrigins, originsList: originsList }), _jsx(Form.Item, { name: "usePPC", valuePropName: "checked", preserve: true, children: _jsx(Checkbox, { children: txt('postprocessing') }) }), _jsx(Form.Item, { name: "useUserLex", label: txt('useReplacementRules'), className: clsx(formStyles.radioGroup, formStyles.label), children: _jsx(Switch, { size: "small" }) })] })),
        },
    ], [
        renderTranscriberSettings,
        profilesForCurrentLanguage,
        profiles,
        allOrigins,
        originsList,
        selectedSource,
    ]);
    return selectedSource === 'mic' ? (_jsxs(_Fragment, { children: [renderTranscriberSettings, _jsx(Form.Item, { name: "usePPC", valuePropName: "checked", preserve: true, children: _jsx(Checkbox, { children: txt('postprocessing') }) })] })) : (_jsxs(_Fragment, { children: [profilesForCurrentLanguage.length === 1 && (_jsx(AfterUploadWarning, { profiles: profiles })), _jsx(Collapse, { className: styles.collapse, ghost: true, bordered: false, accordion: true, items: collapseItems })] }));
};
export default AdvancedSettings;
